import React from "react";
import "./Future.css";
import { Reserveseat } from "./Reserveseat";

import IndustryIcon from "../assets/images/industry-icon.png";
import SessionIcon from "../assets/images/session-icon.png";
import ExpertIcon from "../assets/images/expert-icon.png";
import LearningIcon from "../assets/images/learning-icon.png";
import SoftSkillsIcon from "../assets/images/soft-skills-icon.png";
import IndustrialIcon from "../assets/images/industrial-icon.png";

export const Future = () => {
  return (
    <div className="future-section" id="future-id">
      <div className="future_container">
        <div className="future-content" id="futureid">
          <div className="future-title">
          Key <span>Benefits</span>
          </div>
          <div className="feature-text-section">
            <div className="feature_card-container">
              <div className="feature_card-block">
                <div className="feature-mentor-text">
                  <div className="text-doubt"><strong>1:1 doubt sessions</strong></div>
                  <div className="doubt-icon">
                   <img src={IndustryIcon} />
                  </div>
                </div>
              </div>
              <div className="feature_card-block">
                <div className="feature-mentor-text">
                <div className="text-doubt"><strong>Employment<br></br> Prospects</strong></div>
                  <div className="doubt-icon">
                  <img src={SessionIcon} />
                  </div>
                </div>
              </div>
              <div className="feature_card-block">
                <div className="feature-mentor-text">
                <div className="text-doubt"><strong>Career Guidance</strong></div>  
                <div className="doubt-icon">
                  <img src={ExpertIcon} />
                  </div>
                </div>
              </div>
              <div className="feature_card-block">
                <div className="feature-mentor-text">
                <div className="text-doubt"><strong>Internship <br></br>Opportunity</strong></div>  
                <div className="doubt-icon">
                  <img src={LearningIcon} />
                  </div>
                </div>
              </div>
              <div className="feature_card-block">
                <div className="feature-mentor-text">
                <div className="text-doubt"><strong>Skill Building <br></br>Network</strong></div>  
                <div className="doubt-icon">
                  <img src={SoftSkillsIcon} />
                  </div>
                </div>
              </div>
              <div className="feature_card-block">
                <div className="feature-mentor-text">
                <div className="text-doubt"><strong>Expert Live <br></br>Session</strong></div>  
                <div className="doubt-icon">
                  <img src={IndustrialIcon} />
                  </div>
                </div>
              </div>                                          
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
